import { NavLink, useLocation } from 'react-router-dom'

const LOCALES = ['en', 'vi']

export default function LanguageSwitcher() {
  const { pathname, search, hash } = useLocation()
  const pathAfterLang = pathname.replace(/^\/(en|vi)(?=\/|$)/, '') || '/dashboard'
  const pathWithQuery = `${pathAfterLang}${search}${hash}`

  return (
    <div className="flex items-center rounded-lg border border-border bg-white p-0.5 text-xs">
      {LOCALES.map((code) => {
        const langActive =
          pathname === `/${code}` || pathname.startsWith(`/${code}/`)
        return (
          <NavLink
            key={code}
            to={`/${code}${pathWithQuery}`}
            className={() =>
              `rounded-md px-2.5 py-1 font-medium transition-colors ${
                langActive
                  ? 'text-white bg-primary'
                  : 'text-zinc-500 hover:text-zinc-700'
              }`
            }
          >
            {code.toUpperCase()}
          </NavLink>
        )
      })}
    </div>
  )
}
